import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Button from '../../components/ui/Button';
import CourseCard from './components/CourseCard';
import TeacherCard from './components/TeacherCard';
import FeatureHighlight from './components/FeatureHighlight';
import Icon from '../../components/AppIcon';

const OnlineLearning = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'Video',
      title: 'Live Interactive Classes',
      description: 'Real-time sessions with experienced instructors',
    },
    {
      icon: 'BookOpen',
      title: 'Comprehensive Curriculum',
      description: 'From basics (101) to advanced proficiency',
    },
    {
      icon: 'Award',
      title: 'Certified Instructors',
      description: 'Professional Chinese language teachers',
    },
    {
      icon: 'Globe',
      title: 'Flexible Schedule',
      description: 'Learn at your own pace, anytime, anywhere',
    },
  ];

  const courses = [
    {
      id: 1,
      title: 'Chinese Language 101',
      description: 'Perfect for complete beginners. Learn basic Mandarin, essential phrases, and cultural basics.',
      type: '101',
      level: 'beginner',
      icon: 'BookOpen',
      instructor: 'Li Wei',
      duration: '8 weeks • 24 hours',
      students: 2547,
      rating: 5,
      reviews: 489,
      price: 99,
    },
    {
      id: 2,
      title: 'Intermediate Conversational Chinese',
      description: 'Build confidence in everyday conversations, expand vocabulary, and improve pronunciation.',
      type: '101',
      level: 'intermediate',
      icon: 'MessageCircle',
      instructor: 'Wang Chen',
      duration: '10 weeks • 30 hours',
      students: 1823,
      rating: 5,
      reviews: 324,
      price: 129,
    },
    {
      id: 6,
      title: 'Advanced Mandarin Mastery',
      description: 'Achieve fluency with advanced grammar, idioms, literature analysis, and native-level proficiency.',
      type: '101',
      level: 'advanced',
      icon: 'Brain',
      instructor: 'Prof. Ma Wei',
      duration: '14 weeks • 45 hours',
      students: 654,
      rating: 5,
      reviews: 189,
      price: 179,
    },
    {
      id: 4,
      title: 'HSK Examination Prep',
      description: 'Comprehensive preparation for HSK certification tests with practice exams and expert tips.',
      type: '101',
      level: 'certification',
      icon: 'Award',
      instructor: 'Liu Ming',
      duration: '6 weeks • 20 hours',
      students: 3124,
      rating: 5,
      reviews: 612,
      price: 89,
    },
    {
      id: 3,
      title: 'Intermediate Business Chinese 1',
      description: 'The MOOC of Intermediate Business Chinese is designed for the Chinese language learners who have reached HSK level 3. The MOOC presents lively, authentic, and up-to-date dialogues for daily conversations and business communications. The contents integrate trendy technologies with real-life situations that can be applied to everyday lives, language classrooms, and working places.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Briefcase',
      instructor: 'Shanghai Jiaotong University',
      duration: '5 weeks • 22 hours',
      students: 8500,
      rating: 5,
      reviews: 1234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/intermediate-business-chinese-1',
      category: 'mooc',
    },
    {
      id: 7,
      title: 'Chinese for HSK1',
      description: 'Official Coursera course by Peking University. Master fundamental Chinese language skills and pass the HSK1 certification exam.',
      type: 'mooc',
      level: 'beginner',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 15 hours',
      students: 45000,
      rating: 5,
      reviews: 8234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-1',
      category: 'mooc',
    },
    {
      id: 8,
      title: 'Chinese for HSK2',
      description: 'Welcome to HSK Level 2 course by Peking University! Master 150+ new vocabularies, 62 grammar points, and express your views on common daily topics. Features 24 lecture videos, 44 complementary videos, and comprehensive practice materials.',
      type: 'mooc',
      level: 'beginner',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 34 hours',
      students: 28000,
      rating: 5,
      reviews: 4156,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-2',
      category: 'mooc',
    },
    {
      id: 9,
      title: 'Chinese for HSK 3 Part 1',
      description: 'Official Coursera course by Peking University. Advance to upper-intermediate proficiency with complex grammar and conversational skills.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 15000,
      rating: 5,
      reviews: 2234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3',
      category: 'mooc',
    },
    {
      id: 10,
      title: 'Chinese for HSK 3 Part 2',
      description: 'Official Coursera course by Peking University. Complete HSK3 proficiency with advanced conversational and writing skills.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 12000,
      rating: 5,
      reviews: 1876,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3-part2',
      category: 'mooc',
    },
    {
      id: 11,
      title: 'Chinese for HSK 4',
      description: 'Official Coursera course by Peking University. Reach upper-intermediate proficiency with advanced vocabulary, complex writing, and professional communication.',
      type: 'mooc',
      level: 'intermediate',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 20 hours',
      students: 10000,
      rating: 5,
      reviews: 1543,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-4',
      category: 'mooc',
    },
    {
      id: 12,
      title: 'Chinese for HSK 5',
      description: 'Official Coursera course by Peking University. Achieve advanced proficiency with mastery of complex topics, professional settings, and cultural nuance.',
      type: 'mooc',
      level: 'advanced',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 22 hours',
      students: 7500,
      rating: 5,
      reviews: 1089,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk5',
      category: 'mooc',
    },
    {
      id: 13,
      title: 'Chinese for HSK 6',
      description: 'Official Coursera course by Peking University. Achieve mastery level proficiency with complete fluency in all contexts and native-level comprehension.',
      type: 'mooc',
      level: 'advanced',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 25 hours',
      students: 5000,
      rating: 5,
      reviews: 723,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk-6',
      category: 'mooc',
    },
    // HSK Certification Preparation Courses
    {
      id: 701,
      title: 'Chinese for HSK1',
      description: 'Official Coursera course by Peking University. Master fundamental Chinese language skills and pass the HSK1 certification exam.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 15 hours',
      students: 45000,
      rating: 5,
      reviews: 8234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-1',
      category: 'mooc',
    },
    {
      id: 702,
      title: 'Chinese for HSK2',
      description: 'Welcome to HSK Level 2 course by Peking University! Master 150+ new vocabularies, 62 grammar points, and express your views on common daily topics. Features 24 lecture videos, 44 complementary videos, and comprehensive practice materials.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 34 hours',
      students: 28000,
      rating: 5,
      reviews: 4156,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-2',
      category: 'mooc',
    },
    {
      id: 703,
      title: 'Chinese for HSK 3 Part 1',
      description: 'Official Coursera course by Peking University. Advance to upper-intermediate proficiency with complex grammar and conversational skills.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 15000,
      rating: 5,
      reviews: 2234,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3',
      category: 'mooc',
    },
    {
      id: 704,
      title: 'Chinese for HSK 3 Part 2',
      description: 'Official Coursera course by Peking University. Complete HSK3 proficiency with advanced conversational and writing skills.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '4 weeks • 18 hours',
      students: 12000,
      rating: 5,
      reviews: 1876,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-3-part2',
      category: 'mooc',
    },
    {
      id: 705,
      title: 'Chinese for HSK 4',
      description: 'Official Coursera course by Peking University. Reach upper-intermediate proficiency with advanced vocabulary, complex writing, and professional communication.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 20 hours',
      students: 10000,
      rating: 5,
      reviews: 1543,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/hsk-4',
      category: 'mooc',
    },
    {
      id: 706,
      title: 'Chinese for HSK 5',
      description: 'Official Coursera course by Peking University. Achieve advanced proficiency with mastery of complex topics, professional settings, and cultural nuance.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '5 weeks • 22 hours',
      students: 7500,
      rating: 5,
      reviews: 1089,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk5',
      category: 'mooc',
    },
    {
      id: 707,
      title: 'Chinese for HSK 6',
      description: 'Official Coursera course by Peking University. Achieve mastery level proficiency with complete fluency in all contexts and native-level comprehension.',
      type: 'mooc',
      level: 'certification',
      icon: 'Award',
      instructor: 'Peking University',
      duration: '6 weeks • 25 hours',
      students: 5000,
      rating: 5,
      reviews: 723,
      price: 0,
      courseraUrl: 'https://www.coursera.org/learn/chinese-for-hsk-6',
      category: 'mooc',
    },
  ];

  const mainCategories = [
    { id: '101', label: '101 Courses', type: '101' },
    { id: 'mooc', label: 'MOOC Programs', type: 'mooc' },
  ];

  const subcategories = [
    { id: 'beginner', label: 'Beginner' },
    { id: 'intermediate', label: 'Intermediate' },
    { id: 'advanced', label: 'Advanced' },
    { id: 'certification', label: 'Certification Preparation' },
  ];

  const teachers = [
    {
      name: 'Li Wei',
      specialization: 'Beginner & Fundamentals',
      bio: 'Certified TCFL instructor with 8+ years of experience teaching international students.',
      experience: '8+ years teaching experience',
      studentsCount: 2500,
      rating: 5,
    },
    {
      name: 'Wang Chen',
      specialization: 'Conversational Chinese',
      bio: 'Native speaker focused on practical communication and pronunciation mastery.',
      experience: '10+ years experience',
      studentsCount: 4200,
      rating: 5,
    },
    {
      name: 'Dr. Zhang Lin',
      specialization: 'Business & Professional',
      bio: 'PhD in Applied Linguistics, specialist in business communication and corporate training.',
      experience: 'PhD holder, 12+ years',
      studentsCount: 1800,
      rating: 5,
    },
    {
      name: 'Liu Ming',
      specialization: 'HSK Certification',
      bio: 'Official HSK examiner with proven track record of successful student certifications.',
      experience: 'HSK Examiner, 9+ years',
      studentsCount: 3500,
      rating: 5,
    },
    {
      name: 'Professor Yang Su',
      specialization: 'Culture & Language',
      bio: 'University professor integrating Chinese culture, history, and literature into language learning.',
      experience: 'Professor, 15+ years',
      studentsCount: 2100,
      rating: 5,
    },
    {
      name: 'Prof. Ma Wei',
      specialization: 'Advanced Fluency',
      bio: 'Specializes in advanced learners, native-level proficiency, and cultural nuances.',
      experience: 'Prof., 18+ years',
      studentsCount: 2800,
      rating: 5,
    },
  ];

  const coursesByTypeAndLevel = (courseType, levelId) => {
    return courses.filter(
      (course) => course.type === courseType && course.level === levelId
    );
  };

  const handleEnroll = (courseId) => {
    const course = courses.find((c) => c.id === courseId);
    if (course.category === 'mooc' && course.courseraUrl) {
      window.open(course.courseraUrl, '_blank');
    } else {
      alert(`You've enrolled in: ${course.title}`);
    }
  };

  const handleViewDetails = (courseId) => {
    navigate(`/online-learning/course/${courseId}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-primary/10 to-background">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              Learn Chinese Online
            </h1>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Discover world-class Chinese language courses taught by certified native instructors. From 101 basics to advanced fluency, MOOC programs, and business Chinese.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="default"
                iconName="Play"
                iconPosition="left"
              >
                Watch Demo Class
              </Button>
              <Button
                variant="outline"
                iconName="Download"
                iconPosition="left"
              >
                Download Curriculum
              </Button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
            <div className="bg-card rounded-lg p-6 text-center shadow-warm">
              <Icon name="Users" size={32} color="var(--color-primary)" className="mx-auto mb-2" />
              <div className="text-3xl font-bold text-primary">12,000+</div>
              <div className="text-muted-foreground text-sm">Active Students</div>
            </div>
            <div className="bg-card rounded-lg p-6 text-center shadow-warm">
              <Icon name="BookOpen" size={32} color="var(--color-primary)" className="mx-auto mb-2" />
              <div className="text-3xl font-bold text-primary">50+</div>
              <div className="text-muted-foreground text-sm">Courses Available</div>
            </div>
            <div className="bg-card rounded-lg p-6 text-center shadow-warm">
              <Icon name="Award" size={32} color="var(--color-primary)" className="mx-auto mb-2" />
              <div className="text-3xl font-bold text-primary">6</div>
              <div className="text-muted-foreground text-sm">Expert Teachers</div>
            </div>
            <div className="bg-card rounded-lg p-6 text-center shadow-warm">
              <Icon name="Globe" size={32} color="var(--color-primary)" className="mx-auto mb-2" />
              <div className="text-3xl font-bold text-primary">80+</div>
              <div className="text-muted-foreground text-sm">Countries</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-background">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-4">
            Why Choose Our Courses?
          </h2>
          <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-12">
            Experience comprehensive, interactive Chinese language learning with flexible scheduling and world-class instructors.
          </p>
          <FeatureHighlight features={features} />
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-16 bg-muted/30">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-12">
            Our Courses
          </h2>

          {/* Courses Grid */}
          <div className="space-y-16">
            {mainCategories.map((mainCategory) => (
              <div key={mainCategory.id} className="space-y-6">
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name={mainCategory.id === '101' ? 'BookOpen' : 'Award'} size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
                      {mainCategory.label}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      Choose your level and explore courses
                    </p>
                  </div>
                </div>

                {/* Category Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {subcategories.map((subcat) => {
                    const subCategoryCoursess = coursesByTypeAndLevel(mainCategory.type, subcat.id);
                    if (subCategoryCoursess.length === 0) return null;

                    return (
                      <div
                        key={`${mainCategory.id}-${subcat.id}`}
                        className="bg-card border border-border rounded-lg p-6 hover:shadow-warm transition-smooth flex flex-col"
                      >
                        <div className="flex items-start justify-between mb-4">
                          <div>
                            <h4 className="text-lg font-heading font-semibold text-foreground">
                              {subcat.label}
                            </h4>
                            <p className="text-sm text-muted-foreground mt-2">
                              {subCategoryCoursess.length} course{subCategoryCoursess.length !== 1 ? 's' : ''}
                            </p>
                          </div>
                          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                            <Icon name="Star" size={20} color="var(--color-primary)" />
                          </div>
                        </div>

                        <p className="text-sm text-muted-foreground mb-6 flex-grow">
                          {subcat.label === 'Beginner' && 'Start your journey with foundational concepts'}
                          {subcat.label === 'Intermediate' && 'Build your skills with intermediate topics'}
                          {subcat.label === 'Advanced' && 'Master advanced concepts and techniques'}
                          {subcat.label === 'Certification Preparation' && 'Prepare for certification exams'}
                        </p>

                        <Button
                          variant="default"
                          fullWidth
                          iconName="ArrowRight"
                          iconPosition="right"
                          onClick={() => navigate(`/online-learning/courses/${mainCategory.type}/${subcat.id}`)}
                        >
                          View Courses
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teachers Section */}
      <section className="py-16 bg-background">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-foreground mb-4">
            Meet Our Expert Instructors
          </h2>
          <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-12">
            Learn from certified native speakers with years of international teaching experience.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {teachers.map((teacher, index) => (
              <TeacherCard key={index} teacher={teacher} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary/5 border-t border-border">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            Ready to Start Learning?
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join thousands of students worldwide who are mastering Chinese language with our interactive online courses.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="default"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => handleEnroll(1)}
            >
              Start Your Free Trial
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/user-registration')}
            >
              Create Account
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OnlineLearning;
